import styled from '@emotion/styled';
import { useThemeContext } from '@/features/theme';

export const Container = styled.div(() => {
  const theme = useThemeContext();

  return {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',

    svg: { flexShrink: 0 },

    '&:hover': { color: theme.primaryColor },
  };
});

export const IconContainer = styled.div(() => {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    left: 0,
    top: '50%',
    transform: 'translateY(-50%)',
  };
});

export const Select = styled.select(() => {
  return {
    position: 'relative',
    display: 'block',
    fieldSizing: 'content',
    minWidth: '24px',
    padding: '4px 0',
    paddingLeft: '20px',
    margin: 0,
    backgroundColor: 'transparent',
    border: 'none',
    color: 'inherit',
    boxShadow: 'none',
    '-moz-appearance': 'none',
    '-webkit-appearance': 'none',
    appearance: 'none',
    fontSize: '12px',
    cursor: 'pointer',
    '::-ms-expand': { display: 'none' },
    ':focus': { outline: 'none' },
    ':focus-visible': { outline: 'none' },
  };
});
